import { EMortgageRateHikeBannerStatus } from '../../types/mortgageRateHikeBanner';
import { IApplicationState } from '../../types/redux';

export function selectIsBannerSlotClosed(state: IApplicationState): boolean {
  return state.mortgageRateHikeBannerStatus === EMortgageRateHikeBannerStatus.ClosedDuringSession;
}
